import { useContext } from 'react';
import { RecorderAuthContext } from '../context/RecorderAuthContext';

export default function useRecorderAuth() {
  const ctx = useContext(RecorderAuthContext);

  if (!ctx) {
    throw new Error('useRecorderAuth must be used inside RecorderAuthProvider');
  }

  return ctx;
}